import angular from "angular";
import { Ng1StateDeclaration } from "angular-ui-router";
import { configureStates, resolveFromParam } from "../../../core/router/router-helper.provider";

const routes: { state: string, config: Ng1StateDeclaration }[] = [{
    state: "report",
    config: {
        url: "/report",
        abstract: true
    }
}, {
    state: "report.payrollAnalysisSummary",
    config: {
        url: "/payrollanalysissummary?{startDate:date}&{endDate:date}&{programID:int}&{retailerID:int}&{owner}",
        component: "apexPayrollAnalysisSummary",
        dynamic: true,
        resolve: {
            startDate: resolveFromParam("startDate"),
            endDate: resolveFromParam("endDate"),
            programID: resolveFromParam("programID"),
            retailerID: resolveFromParam("retailerID"),
            owner: resolveFromParam("owner")
        },
        data: {
            pageHeader: "Payroll Analysis Summary"
        }
    }
}, {
    state: "report.payrollAnalysis",
    config: {
        url: "/payrollanalysis/{payrollID:int}?{programID:int}&{storeID:int}",
        component: "apexPayrollAnalysis",
        dynamic: true,
        resolve: {
            payrollID: resolveFromParam("payrollID"),
            programID: resolveFromParam("programID"),
            storeID: resolveFromParam("storeID")
        },
        data: {
            pageHeader: "Payroll Analysis"
        }
    }
}, {
    state: "report.workersCompensation",
    config: {
        url: "/workersCompensation",
        component: "apexWorkersCompensationDashboard",
        dynamic: true,
        data: {
            PageHeader: "Workers Compensation"
        }
    }
}
];

export const PayrollReportsRoutingModule = angular
    .module("apex.mainApp.payroll.reports.routing", [])
    .run(configureStates(routes))
    .name;
